
import config from "@/assets/config";
import { common } from "@/mixins/common";
export default {
  mixins: [common],
  layout: "blank",
  data() {
    return {
      disBtn: false,
      showMenu: true,
      user: "",
      loading: true,
      alertType: "info",
      message: "",
    };
  },
  beforeMount() {
    this.cargarPagina();
  },
  methods: {
    async getUser() {
      try {
        if (this.$refs.formData.validate()) {
          this.disBtn = true;
          this.loading = true;
          let url = config.api.url + "buscar_correo/" + this.user;
          let mail = await this.$axios.get(url);
          let res = mail.data;

          if (res.info.correo.length > 0) {
            this.alertType = "success";
            let prom = await this.enviarCorreo(res.info);
            this.loading = false;
            this.showMenu = false;
            this.message = this.$t("recuperacionClave.smsOk");
          } else {
            this.loading = false;
            this.showMenu = false;
            this.alertType = "warning";
            this.message = this.$t("recuperacionClave.smsError");
          }
        }
      } catch (error) {
        this.showMenu = false;
        this.icon = "error";
        this.alertType = "error";
        this.message = this.$t("recuperacionClave.smsUsuarioNoEncontrado");
        this.loading = false;
      }
    },
    async cargarPagina() {
      this.$store.commit("resetAuth");
      this.$axios.setToken(false);
      this.loading = false;
      return "Carga completa";
    },
    async enviarCorreo(usuario) {
      let url = config.api.url + "enviar_correo/";
      let prom = await this.$axios.put(url, usuario);
      let res = prom.data;
      return "ok";
    },
  },
};
